import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class CreateMultiOpenAccessPassSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '6715bc4197d040f18979b12bedfdadee';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.CreateMultiOpenAccessPass;

  private constructor(
    public readonly templateId: string,
    public readonly variationId: string | null,
    public readonly overridePassPriceWithTicket: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return CreateMultiOpenAccessPassSideEffect.TYPE_ID;
  }

  static create(args: {
    templateId: string,
    variationId: string | null,
    overridePassPriceWithTicket: boolean,
  }): CreateMultiOpenAccessPassSideEffect {
    return new CreateMultiOpenAccessPassSideEffect(
        args.templateId,
        args.variationId,
        args.overridePassPriceWithTicket,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): CreateMultiOpenAccessPassSideEffect {
    return new CreateMultiOpenAccessPassSideEffect(
        MapUtils.getString(map, 'templateId'),
        MapUtils.getStringOrNull(map, 'variationId'),
        MapUtils.getBoolean(map, 'overridePassPriceWithTicket'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
      'templateId': this.templateId,
      'variationId': this.variationId,
      'overridePassPriceWithTicket': this.overridePassPriceWithTicket,
    };
  }

  clone(): this {
    return new CreateMultiOpenAccessPassSideEffect(
        this.templateId,
        this.variationId,
        this.overridePassPriceWithTicket,
    ) as this;
  }

  isSame(other: CreateMultiOpenAccessPassSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType &&
      other.templateId === this.templateId &&
      other.variationId === this.variationId &&
      other.overridePassPriceWithTicket === this.overridePassPriceWithTicket;
  }

  toLegacyOrderHook(): LegacyOrderHook | null {
    return null;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CreateMultiOpenAccessPassSideEffect;
  }

  static assertType(order: DataModel): order is CreateMultiOpenAccessPassSideEffect {
    return order instanceof CreateMultiOpenAccessPassSideEffect;
  }
}

export class CreateMultiOpenAccessPassSideEffectBuilder extends DataModelBuilder<CreateMultiOpenAccessPassSideEffect> {
  build(context: SerializationContext, map: SerializedData): CreateMultiOpenAccessPassSideEffect {
    return CreateMultiOpenAccessPassSideEffect.fromMap(context, map);
  }
}
